export default __webpack_public_path__ + "build/9a901687cb17727a8c1404c1cff4077c.gif";